import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStandardCodeVersionLookup extends Layout {
    sourceStandardCodeVersionLookup: DataSource;
    tableStandardcodeVersion: Table;
}
